<template>
    <v-app id="inspire" class="app">
        <app-default-layout></app-default-layout>
    </v-app>
</template>
<script>
import AppDefaultLayout from "@/components/layout/app-default-layout.vue"
export default {
    name: "App",
    components: {
        AppDefaultLayout
    },
};
</script>
